/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=ba95c498&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=ba95c498&lang=scss"

import exportComponent from "/Users/rathasitjearnpasawarn/var/apps/myculture/runner/assessment-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__